import { Phone, EnvelopeSimple, MapPin, FacebookLogo, InstagramLogo, Clock, ArrowRight, Star } from "@phosphor-icons/react";
import { COMPANY } from "../data/site";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";

const MAP_SRC =
  "https://www.google.com/maps?q=1A+Route+de+Sion+54116+Praye&output=embed";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        index="04"
        eyebrow="Contact"
        title="Parlons de votre projet."
        intro="Une question, un projet ou un dépannage ? Appelez-nous ou écrivez-nous directement — nous vous répondons avec plaisir."
      />

      <section className="mx-auto max-w-7xl px-6 pb-24 md:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          {/* Left: contact info */}
          <div className="lg:col-span-6">
            <Reveal>
              <div className="space-y-8">
                <a href={COMPANY.phoneLink} data-testid="contact-phone" className="group block border-b border-[#EEF0F6] pb-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9aa0b4]">Téléphone</p>
                  <p className="mt-2 flex items-center gap-3 text-3xl font-bold tracking-tight text-[#14183A] transition-colors group-hover:text-[#FF3123] md:text-4xl">
                    <Phone weight="fill" className="h-7 w-7 text-[#FF3123]" /> {COMPANY.phone}
                  </p>
                </a>
                <a href={`mailto:${COMPANY.email}`} data-testid="contact-email" className="group block border-b border-[#EEF0F6] pb-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9aa0b4]">E-mail</p>
                  <p className="mt-2 flex items-center gap-3 text-xl font-semibold tracking-tight text-[#14183A] transition-colors group-hover:text-[#1A49F7] md:text-2xl">
                    <EnvelopeSimple className="h-6 w-6 text-[#3CC0E7]" /> {COMPANY.email}
                  </p>
                </a>
                <div className="border-b border-[#EEF0F6] pb-6">
                  <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9aa0b4]">Adresse</p>
                  <p className="mt-2 flex items-start gap-3 text-lg font-medium text-[#14183A]">
                    <MapPin weight="fill" className="mt-1 h-6 w-6 shrink-0 text-[#1A49F7]" />
                    <span>{COMPANY.address.full}<br />{COMPANY.address.department}</span>
                  </p>
                </div>
                <div className="flex items-start gap-3 rounded-2xl bg-[#F3F6FF] p-5">
                  <Clock weight="light" className="mt-0.5 h-6 w-6 shrink-0 text-[#FC8529]" />
                  <p className="text-sm text-[#5b6072]">Contactez-nous pour connaître nos disponibilités.</p>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Right: map */}
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="overflow-hidden rounded-[2rem] border border-[#EEF0F6]">
                <iframe
                  title="Localisation Lisse Energies - Praye"
                  src={MAP_SRC}
                  className="h-[300px] w-full md:h-[420px]"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </Reveal>
          </div>
        </div>

        {/* Social + reviews — prominent */}
        <Reveal>
          <div className="relative mt-16 overflow-hidden rounded-[2rem] bg-[#14183A] px-8 py-12 text-white md:px-16 md:py-16">
            <span aria-hidden="true" className="decor-blob -right-16 -top-16" style={{ width: 300, height: 300, backgroundColor: "#1A49F7", opacity: 0.35 }} />
            <div className="relative flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
              <div>
                <h2 className="text-3xl font-bold tracking-tight md:text-4xl">Suivez-nous</h2>
                <p className="mt-3 max-w-md text-white/60">Retrouvez nos chantiers et actualités sur les réseaux, et découvrez nos avis clients.</p>
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <a
                  href={COMPANY.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-facebook"
                  className="inline-flex items-center gap-3 rounded-full bg-[#1A49F7] px-6 py-4 font-semibold transition-all duration-300 hover:scale-105"
                >
                  <FacebookLogo weight="fill" className="h-6 w-6" /> Facebook
                </a>
                <a
                  href={COMPANY.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-instagram"
                  className="inline-flex items-center gap-3 rounded-full px-6 py-4 font-semibold transition-all duration-300 hover:scale-105"
                  style={{ background: "linear-gradient(45deg, #FC8529, #FF3123, #1A49F7)" }}
                >
                  <InstagramLogo weight="fill" className="h-6 w-6" /> Instagram
                </a>
                <a
                  href={COMPANY.googleReviews}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-google-reviews"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-4 font-semibold transition-all duration-300 hover:border-[#FC8529] hover:text-[#FC8529]"
                >
                  <Star weight="fill" className="h-5 w-5 text-[#FC8529]" /> Voir nos avis Google
                  <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
